import {transient, autoinject, BindingEngine, useView} from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { LookupClientService } from "../../../../../../services/lookups/lookup-client.service";
import { LookupValueRequest } from "../../../../../../models/lookups/lookup.models";
import { QueryFilter, SourceType, DataGridColumnHelper } from "../../../../../../models/queries/queries.models";
import { CustomGridPageBase } from "../../../../common/custom-grid-page.base";
import { CustomReportModel } from "../../../../../../models/custom-reports/custom-reports.models";
import * as Enumerable from "linq";

@autoinject()
@transient()
@useView('views/pages/modules/custom-reports/custom-report/steps/custom-report-items.html')
export class CustomReportItems extends CustomGridPageBase {

    public filters: QueryFilter[];
    public customReportType: string;

    constructor(private lookupClientService: LookupClientService,
        i18N: I18N, protected bindingEngine: BindingEngine) {
        super(i18N, "Report Items", bindingEngine);
    }

    activate(item: CustomReportModel) {
        this.lookupClientService.getLookup(new LookupValueRequest("RS_CustomReportTypes")).then(response => {
            const reportType = response.activeValues.filter(c => c.id == item.customReportTypeId)[0];
            
            if(reportType && reportType.additionalData && reportType.additionalData.uri){
                this.customReportType = reportType.additionalData.uri;
            }

            this.columns = JSON.parse(item.selectClause);
            this.filters = JSON.parse(item.whereClause);

            this.columns = Enumerable.from(this.columns).orderBy(c => c.columnOrder).toArray();
            this.columns.forEach(c => c.isFilterable = false);

            this.columns.forEach(col => {
                DataGridColumnHelper.applyDataGridColumnOverride(col, col);
            });
            
            this.itemSource = {
                columns: this.columns.filter(c => !c.isHidden).filter((a, index) => index <= 12),
                initialFilters: this.filters,
                sourceType: SourceType.ODataUrl,
                source: "odata/" + this.customReportType + "?customReportId=" + item.customReportId
            };
        });
    }
}